/**
 * Created by zhangsanfeng on 2019/11/19.
 */

import axios from 'axios';
import qs from 'qs';
import {apiPrefix} from '../../config.js';
import {tool} from './tool.js';
import request from './request.js';
import router from '../../router.js';

export const api = {
  //人员实时显示
  currentDisplay: (data) => {
    return request({
      url: `${apiPrefix}/api/v1/currentDisplay`,
      params: data,
      method: 'get'
    })
  },

  //历史轨迹回放
  trackHistory: (data) => {
    return request({
      url: `${apiPrefix}/api/v1/track/history`,
      params: data,
      method: 'get'
    })
  },

  user: {
    login: (data) => {
      return request({
        url: `${apiPrefix}/api/v1/signin`,
        data: data,
        method: 'post'
      })
    }
  },
  deck: {
    list: (data) => {
      return request({
        url: `${apiPrefix}/api/v1/deck/list`,
        params: data,
        method: 'get'
      })
    },
    add: (data) => {
      return request({
        url: `${apiPrefix}/api/v1/deck/add`,
        data: data,
        method: 'post'
      })
    },
    del: (data) => {
      return request({
        url: `${apiPrefix}/api/v1/deck/del`,
        data: data,
        method: 'post'
      })
    },
    one: (data) => {
      return request({
        url: `${apiPrefix}/api/v1/deck/find`,
        params: data,
        method: 'get'
      })
    },
  },

  //船舱总段
  section: {
    list: (data) => {
      return request({
        url: `${apiPrefix}/api/v1/section/list`,
        params: data,
        method: 'get'
      })
    },
    add: (data) => {
      return request({
        url: `${apiPrefix}/api/v1/deck/add`,
        data: data,
        method: 'post'
      })
    },
    del: (data) => {
      return request({
        url: `${apiPrefix}/api/v1/section/del`,
        data: data,
        method: 'post'
      })
    },
    one: (data) => {
      return request({
        url: `${apiPrefix}/api/v1/deck/find`,
        params: data,
        method: 'get'
      })
    },
  },

  station: {
    list: (data) => {
      return request({
        url: `${apiPrefix}/api/v1/station/list`,
        params: data,
        method: 'get'
      })
    }
  },

  upload: {
    upload: (data) => {
      return request({
        url: `${apiPrefix}/file/upload`,
        data: data,
        method: 'post'
      })
    },
    getFileById: (id) => {
      return request({
        url: `${apiPrefix}/file/id/${id}`,
        method: 'get'
      })
    }
  }
};







